import React from 'react'

import { Picker, RadioGroup, Row, Span } from 'components'
import { SPACING } from 'utils'

export interface TypeDate {
  tipoRelatorio: boolean
  changeTipo: (_x: boolean) => void
  handleChangePeriodo: (_date: Date | string, t: 'inicio' | 'fim') => void
  dataIni: Date | string
  dataFim: Date | string
}
const TypeDate: React.FC<TypeDate> = ({
  tipoRelatorio,
  dataFim,
  dataIni,
  handleChangePeriodo,
  changeTipo
}) => {
  const tipoOptions = [
    { label: 'Contrato', value: true },
    { label: 'Fornecedor', value: false }
  ]

  return (
    <Row alignItems="flex-start" justifyContent="space-between">
      <Row>
        <RadioGroup
          label="Tipo"
          row
          listOptions={tipoOptions}
          defaultValue={tipoRelatorio}
          value={tipoRelatorio}
          formValue="tipoContrato"
          onChange={() => changeTipo(!tipoRelatorio)}
        />
      </Row>
      <Row alignItems="flex-start">
        <Picker
          onChange={(e) => handleChangePeriodo(e, 'inicio')}
          value={dataIni}
          maxDate={dataFim}
          label="Periodo Validade"
          showClearButton={false}
        />
        <Span
          text="à"
          fontSize="1rem"
          marginTop={SPACING.spacing30}
          marginLeft={SPACING.spacing20}
          marginRight={SPACING.spacing20}
        />
        <Picker
          onChange={(e) => handleChangePeriodo(e, 'fim')}
          value={dataFim}
          minDate={dataIni}
          label=""
          showClearButton={false}
        />
      </Row>
    </Row>
  )
}

export default TypeDate
